import Group from 'components/utils/Group'
import type { PropsWithChildren } from 'react'
import React from 'react'
import styled from 'styled-components'

const Container = styled(Group)``

function AccommodationPackageTileInclusions(props: PropsWithChildren) {
  return <Container {...props} direction="vertical" gap={8} />
}

export default AccommodationPackageTileInclusions
